module.exports = __webpack_public_path__ + "static/media/ils_loan_failed.53e2d34c.svg";